import { Record } from 'immutable';

const AgencyConfigLookupRecord = Record({
  agencyId: null,
});

export class AgencyConfigLookup extends AgencyConfigLookupRecord {
  agencyId: string;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/config/agency-config-lookup.ts